import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/module.auth.js'
import service from '@/store/module.service.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth: auth,
    service: service
  }
})
